<script lang="ts" setup>
import { type DefineComponent, type HTMLAttributes } from 'vue'

import AButtons, { type AButtonsItemInterface } from '../AButton/AButtons.vue'
import { ACard, CardContent } from '.'

// Props
const properties = defineProps<{
  class?: HTMLAttributes['class']
  title?: string
  description?: string
  items?: AButtonsItemInterface[]
  icon: DefineComponent
  border?: boolean
}>()
// end Props

// Emits
// end Emits

// Refs
// end Refs

// Computed
// end Computed

// Functions
// end Functions

// Async Api functions
// end Async Api functions

// Lifecycle Hooks / Init
// end Lifecycle Hooks / Init
</script>

<template>
  <ACard :border="border" :class="['atabix-callout-card', properties.class]">
    <CardContent class="atabix-callout-card__content">
      <div class="atabix-callout-card__content-icon-container">
        <slot :icon="icon" name="icon">
          <component :is="icon" v-if="icon" class="atabix-callout-card__content-icon" />
        </slot>
      </div>

      <div class="atabix-callout-card__content-message">
        <slot name="title" :title="title">
          <h5 v-if="title" class="atabix-callout-card__content-message-title">
            {{ title }}
          </h5>
        </slot>

        <slot :description="description" name="description">
          <p v-if="description" class="atabix-callout-card__content-message-description">
            {{ description }}
          </p>
        </slot>
      </div>

      <slot :items="items || []" name="buttons">
        <AButtons v-if="items?.length" :items="items || []" />
      </slot>
    </CardContent>
  </ACard>
</template>

<style lang="scss" scoped>
.atabix-callout-card {
  @apply flex;
  @apply items-center;
  @apply justify-center;
}

.atabix-callout-card__content {
  @apply flex;
  @apply flex-col;
  @apply items-center;
  @apply self-stretch;
  @apply justify-center;
  @apply gap-6;
  @apply w-full;
  @apply h-auto;
  @apply text-center;
}

.atabix-callout-card__content-message {
  @apply flex flex-col gap-2;
}

.atabix-callout-card__content-message-title {
  @apply text-xl;
  @apply font-semibold;
  @apply text-form-foreground-label;
}

.atabix-callout-card__content-message-description {
  @apply text-base;
  @apply text-center;
  @apply text-form-foreground-label;
}

.atabix-callout-card__content-icon-container {
  @apply rounded-full;
  @apply w-20;
  @apply h-20;
  @apply flex;
  @apply justify-center;
  @apply items-center;
  @apply text-base;
  @apply bg-background-selected;
}

.atabix-callout-card__content-icon {
  @apply w-10;
  @apply h-10;
  @apply text-foreground-accent;
  @apply fill-foreground-accent;
  @apply stroke-1;
  stroke-linecap: round;
}
</style>
